import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HeaderComponent } from './components/layouts/header/header.component';
import { FooterComponent } from './components/layouts/footer/footer.component';
import { LayoutComponent } from './components/layouts/layout/layout.component';

import { LoadingComponent } from './components/loader/loader.component';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
// Importing custom http interceptors
import { MaterialComponentsModule } from './material-components.module';
import { AuthenticationService } from './services/authentication.service';
import { SideBarComponent } from './components/side-bar/side-bar.component';
import { MatTreeModule } from '@angular/material/tree';
import { AutoLogoutComponent } from './components/auto-logout/auto-logout.component';
import { BottomNavBarComponent } from './components/layouts/bottom-nav-bar/bottom-nav-bar.component';
import { SubHeaderComponent } from './components/layouts/sub-header/sub-header.component';
import { ResumeOrStartPopupComponent } from './components/layouts/resume-or-start-popup/resume-or-start-popup.component';
import { LoaderInnerComponent } from './components/loader-inner/loader-inner.component';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';

const COMPONENTS = [
  HeaderComponent,
  FooterComponent,
  LayoutComponent,
  LoadingComponent,
  SideBarComponent,
  SubHeaderComponent,
  LoaderInnerComponent,
];
// const providers = [AuthenticationService];

@NgModule({
  declarations: [
    ...COMPONENTS,
    AutoLogoutComponent,
    BottomNavBarComponent,
    ResumeOrStartPopupComponent,
  ],
  imports: [
    CommonModule,
    HttpClientModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    MaterialComponentsModule,
    MatTreeModule,
    NgxSkeletonLoaderModule,
  ],
  // providers: [providers],
  exports: [MaterialComponentsModule, ...COMPONENTS],
})
export class ThemeModule {}
